module.exports = __webpack_public_path__ + "static/js/opponent-webworker.3c201882.chunk.worker.js"